module.exports = __webpack_public_path__ + "img/detailthree_title.643d8285.png";